<template>
  <div>
    <PersonalCreate :createPath="createPath" :editPath="editPath" cuerpo-tecnico>
    </PersonalCreate>
  </div>
</template>

<script>
import PersonalCreate from '../components/PersonalCreate'

export default {
  components: {
    PersonalCreate
  },
  data () {
    return {
      createPath: 'cuerpo-tecnico/new',
      editPath: `cuerpo-tecnico/${this.$route.params.id}/${this.$route.params.idClub}`
    }
  }
}
</script>
